import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBIcon,
    MDBRow, MDBCol
  } from 'mdbreact';
  import { api } from '../../api';
  import Swal from 'sweetalert2'

export default class Modaleditstatus extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,
    id_room:'',
    numberroom:'',

      //timecheck
      id_time: "",
      Depositkey: "",
      Differences: "",
      pic_idcard: "",
      price: "",
      roommove: "",
      status: "1",
      status_Depositkey: "",
      sumprice: "",
      tel: "",
      temporary: "",
      timeend: "",
      timestart: "",
  
      //report
      Depositkey1: "",
      endtimereport: "",
      id_memberreport: "",
      id_reportlist: "",
      numberroommove: "",
      starttimereport: "",
      status1: "1",
      status_Depositkey1: "",
      sumpricereport: "",
      tel1: "",

}

 this.updatestatusopenroom = this.updatestatusopenroom.bind(this);
 this.gettimecheck = this.gettimecheck.bind(this);
 this.getreportlist = this.getreportlist.bind(this);
 this.updatescontinueroom = this.updatescontinueroom.bind(this);
// this.toggle = this.toggle.bind(this);
// this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}

toggle = () => {
    this.setState({
      modal: !this.state.modal,
      id_room: this.props.id_room ,
      numberroom: this.props.numberroom
    });
    this.gettimecheck();
    this.getreportlist();
  }

  gettimecheck (){
    // this.setState({ loading:true})
       api.get('lkselectroomidtimeend2.php?roomid='+this.props.id_room)
       .then(res => {
         console.log(res.data);

        
        this.setState({ 
            id_time: res.data[0].id_time,
            pic_idcard: res.data[0].pic_idcard,
            timestart: res.data[0].timestart,
            timeend: res.data[0].timeend,
            price: res.data[0].price,
            Differences: res.data[0].Differences,
            sumprice: res.data[0].sumprice,
            temporary: res.data[0].temporary,
            Depositkey: res.data[0].Depositkey,
            status_Depositkey: res.data[0].status_Depositkey,  
            tel: res.data[0].tel,
            status: res.data[0].status,
          
          
        })
        // this.setState({ room: res.data})
       }) 
   }

   getreportlist (){
    // this.setState({ loading:true})
       api.get('lkselectroomreportid2.php?roomid='+this.props.id_room)
       .then(res => {
       //  console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ 
            Depositkey1: res.data[0].Depositkey,
            endtimereport: res.data[0].endtimereport,
            id_memberreport: res.data[0].id_memberreport,
            id_reportlist: res.data[0].id_reportlist,
            numberroommove: res.data[0].numberroommove,
            starttimereport: res.data[0].starttimereport,
            status1: res.data[0].status,
            status_Depositkey1: res.data[0].status_Depositkey,
            sumpricereport: res.data[0].sumpricereport,
            tel1: res.data[0].tel,
         })
       }) 
   }

  updatestatusopenroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);
      api.post("lkupdatestatusroom.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'เปิดห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }

  updatescontinueroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);//
      datafrm.append("numberroom", this.state.numberroom);
    
      datafrm.append("id_time", this.state.id_time);
      datafrm.append("Depositkey", this.state.Depositkey);
      datafrm.append("Differences", this.state.Differences);
      datafrm.append("pic_idcard", this.state.pic_idcard);
      datafrm.append("price", this.state.price);
      datafrm.append("roommove", this.state.roommove);
      datafrm.append("status", this.state.status);
      datafrm.append("status_Depositkey", this.state.status_Depositkey);
      datafrm.append("sumprice", this.state.sumprice);
      datafrm.append("tel", this.state.tel);
      datafrm.append("temporary", this.state.temporary);
      datafrm.append("timeend", this.state.timeend);
      datafrm.append("timestart", this.state.timestart);

      datafrm.append("Depositkey1", this.state.Depositkey1);
      datafrm.append("endtimereport", this.state.endtimereport);
      datafrm.append("id_memberreport", this.state.id_memberreport);
      datafrm.append("id_reportlist", this.state.id_reportlist);
      datafrm.append("numberroommove", this.state.numberroommove);
      datafrm.append("starttimereport", this.state.starttimereport);
      datafrm.append("status1", this.state.status1);
      datafrm.append("status_Depositkey1", this.state.status_Depositkey1);
      datafrm.append("sumpricereport", this.state.sumpricereport);
      datafrm.append("tel1", this.state.tel1);
      api.post("lksavestaycontinue.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'ต่อห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }


  render() {
    console.log(this.state.id_room)
    return (
      <MDBContainer>
        <MDBBtn color="dark" onClick={this.toggle}><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>จัดการห้อง </MDBModalHeader>

          <MDBModalBody>
          <h3>ห้องที่ {this.props.numberroom}</h3> 
          <MDBRow>
          <MDBCol sm="6"> <MDBBtn color="deep-purple" onClick={this.updatestatusopenroom}><MDBIcon icon="bed" /> เปิดใช้ห้อง</MDBBtn></MDBCol>
          <MDBCol sm="6"> <MDBBtn color="cyan" onClick={this.updatescontinueroom}><MDBIcon icon="bed" /> ต่อห้อง</MDBBtn></MDBCol>
          </MDBRow>
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle}>ปิด</MDBBtn>
            {/* <MDBBtn color="primary" size="sm">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    )
  }
}
